module.exports = __webpack_public_path__ + "static/media/story_14.debef0d9.jpg";